import React, { Component } from 'react';
import { isEmpty, isWaterDevice } from '../../../Common/Common';

export default class Water_Devices extends Component {
	constructor(props) {
		super(props);

		this.mp_ids = [];
		for (let point_id in this.props.data) {
			let point_info = window.app.state.point_list[point_id];
			if (!isEmpty(point_info)) {
				if (isWaterDevice(point_info)) this.mp_ids.push(point_id);
			}
		}

		this.state = {

		}
	}

	render() {
		let card_style = {
			overflow: 'auto',
			width: this.props.width - 40,
			marginLeft: 'auto',
			marginRight: 'auto',
			boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)',
			borderRadius: 20,
			paddingBottom: 10,
			marginTop: 20,
		}

		let row_style = {
			background: 'white',
			padding: '0px 10px',
			width: this.props.width - 60,
			marginLeft: 'auto',
			marginRight: 'auto',
			marginTop: 10,
			textAlign: 'left',
		}

		let cell_width = 75;
		let header_width = this.props.width - 220;
		let device_name_width = this.props.width - 280;
		let hour_width = 60;
		let font_style = {
			fontSize: 12,
		}

		if (this.props.width > 500) {
			font_style = { fontSize: 14 };
			cell_width = 90;
			header_width = this.props.width - 250;
			device_name_width = this.props.width - 310;
		}

		return (
			<div style={card_style}>
				<div style={{ textAlign: 'left', marginLeft: 10 }}>
					<span className="header">{this.props.receiver.getString('water_devices') + ' (m³)'}</span>
				</div>
				<div style={row_style}>
					<div style={{ display: 'inline-block', marginRight: 5, width: header_width, textAlign: 'right' }}>
						<span>{this.props.receiver.getString('hour')}</span>
					</div>
					<div style={{ display: 'inline-block', marginRight: 5, width: cell_width, textAlign: 'right' }}>
						<span>{this.props.receiver.getString('day')}</span>
					</div>
					<div style={{ display: 'inline-block', width: cell_width, textAlign: 'right' }}>
						<span>{this.props.receiver.getString('month')}</span>
					</div>
				</div>
				{this.mp_ids.map((point_id) => {
					let point_info = window.app.state.point_list[point_id];
					if (!isEmpty(point_info)) {
						let name = point_info.name;
						let hour_val = this.props.data[point_id].hour;
						let day_val = this.props.data[point_id].day;
						let month_val = this.props.data[point_id].month;
						return (
							<div style={row_style}>
								<div style={{ display: 'inline-block', width: device_name_width }}>
									<span style={font_style}>{name}</span>
								</div>
								<div style={{ display: 'inline-block', marginRight: 5, width: cell_width, textAlign: 'right' }}>
									<span style={font_style}>{hour_val}</span>
								</div>
								<div style={{ display: 'inline-block', marginRight: 5, width: cell_width, textAlign: 'right' }}>
									<span style={font_style}>{day_val}</span>
								</div>
								<div style={{ display: 'inline-block', width: cell_width, textAlign: 'right' }}>
									<span style={font_style}>{month_val}</span>
								</div>
							</div>
						)
					}
				})}
			</div>
		)
	}
}